import { css } from "@emotion/react";

export const soloLogoContainer = css`
  width: 15rem;
  height: 2.15rem;
`;

export const svgContainer = css`
  ${soloLogoContainer}
  margin-top: 1rem;
`;

export const container = css`
  padding: 1rem;
  margin: auto;
  max-width: 15rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;
